import { ButtonGroup } from "@wayflyer/flyui";
import { useState } from "react";
import { useIntl } from "react-intl";

import { PAGE_TYPE, useFundingApplicationNavigation } from "../../../hooks/navigation-next";
import { COMMON_MESSAGES } from "../../common-messages";

export const ConnectorNavigationGroup = ({ hasConnections, forSlug }: { hasConnections: boolean; forSlug: string }) => {
  const navigationContext = useFundingApplicationNavigation({
    currentPage: PAGE_TYPE.CONNECTORS,
    currentStep: forSlug,
  });
  const [isPrimarySubmitting, setIsPrimarySubmitting] = useState(false);
  const [isTertiarySubmitting, setIsTertiarySubmitting] = useState(false);
  const intl = useIntl();

  return (
    <ButtonGroup
      primaryAction={{
        onAction: async () => {
          if (navigationContext.nextPath) {
            setIsPrimarySubmitting(true);
            await navigationContext.navigateWithStateUpdate(navigationContext.nextPath);
            setIsPrimarySubmitting(false);
          }
        },
        content: intl.formatMessage(COMMON_MESSAGES.nextLabel),
        disabled: !hasConnections,
        loading: isPrimarySubmitting,
        analyticsId: `platform-connect-next-button`,
      }}
      secondaryAction={{
        onAction: () => {
          if (navigationContext.previousPath) {
            navigationContext.navigate(navigationContext.previousPath);
          }
        },
        content: intl.formatMessage(COMMON_MESSAGES.backLabel),
        analyticsId: `platform-connect-back-button`,
      }}
      tertiaryAction={{
        onAction: async () => {
          if (navigationContext.nextPath) {
            setIsTertiarySubmitting(true);
            await navigationContext.navigateWithStateUpdate(navigationContext.nextPath);
            setIsTertiarySubmitting(false);
          }
        },
        content: intl.formatMessage(COMMON_MESSAGES.skipLabel),
        disabled: hasConnections,
        loading: isTertiarySubmitting,
        analyticsId: `platform-connect-skip-button`,
      }}
      primaryActionTestId="navigation-continue-button"
      secondaryActionTestId="navigation-back-button"
      tertiaryActionTestId="navigation-skip-button"
    />
  );
};
